<div class="bg-gradient-to-br from-blue-50 via-white to-indigo-50 dark:from-slate-900 dark:via-slate-900 dark:to-slate-900 p-4">
  <div class="max-w-5xl mx-auto">
    <!-- Barre de progression -->
    <app-progress-bar
      [currentStep]="currentStep"
      [totalSteps]="totalSteps"
    ></app-progress-bar>

    <!-- Message de bienvenue -->
    <div
      class="mt-2 mb-3 p-3 bg-white dark:bg-slate-800 rounded-lg shadow-sm dark:shadow-slate-900/30 border border-purple-100"
      >
      <h1 class="text-lg font-bold mb-1 text-purple-900">
        👋 Bienvenue chez Predivent !
      </h1>
      <p class="text-gray-700 dark:text-gray-300 text-sm leading-snug">
        Nous allons configurer votre compte ensemble en quelques étapes simples.
        Cela ne prendra que quelques minutes et nous permettra de personnaliser
        l'outil selon vos besoins.
      </p>
    </div>

    <!-- Titre et description -->
    <h2 class="text-base font-bold mb-1">Quel est votre type d'activité ?</h2>
    <p class="text-gray-600 dark:text-gray-400 text-xs mb-3">
      Sélectionnez le modèle qui correspond à votre activité commerciale.
    </p>

    <!-- Grille de sélection - 2 options -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-3 mb-3">
      @for (option of merchantOptions; track option) {
        <button
          (click)="selectType(option.id)"
          class="p-3 rounded-lg font-medium transition-all duration-200 border-2 flex flex-col text-left w-full group overflow-hidden relative"
        [ngClass]="{
          'bg-green-50 dark:bg-green-900/20 border-green-500 text-green-900 shadow-lg dark:shadow-slate-900/50':
            selectedType === option.id,
          'bg-white dark:bg-slate-800 border-gray-200 dark:border-slate-700 text-gray-700 dark:text-gray-300 hover:border-green-300 hover:shadow-md dark:shadow-slate-900/50':
            selectedType !== option.id,
        }"
          >
          <!-- Emoji principal -->
          <div class="text-2xl mb-1 transition-transform duration-200">
            {{ option.emoji }}
          </div>
          <!-- Label et description -->
          <h3 class="text-base font-bold mb-1">{{ option.label }}</h3>
          <p class="text-xs mb-1 opacity-80">{{ option.description }}</p>
          <!-- Détails -->
          <ul class="space-y-0.5">
            @for (detail of option.details; track detail) {
              <li
                class="text-xs flex items-start gap-1"
                >
                <span class="text-sm leading-none">•</span>
                <span>{{ detail }}</span>
              </li>
            }
          </ul>
          <!-- Checkmark pour sélection -->
          @if (selectedType === option.id) {
            <div
              class="absolute top-4 right-4 w-6 h-6 bg-green-600 rounded-full flex items-center justify-center text-white"
              >
              <svg
                class="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="3"
                  d="M5 13l4 4L19 7"
                ></path>
              </svg>
            </div>
          }
        </button>
      }
    </div>

    <!-- Boutons de navigation -->
    <div class="flex justify-between mb-2 mt-6">
      <!-- Si premier step, on met un div vide pour garder l'alignement -->
      @if (currentStep === 1) {
        <div class="w-28"></div>
      }

      <!-- Bouton Continuer -->
      <button
        class="flex items-center gap-2 px-4 py-1.5 text-sm font-medium rounded-lg transition-all"
        [ngClass]="{
          'bg-indigo-600 hover:bg-indigo-700 text-white shadow-md dark:shadow-slate-900/50 hover:shadow-lg dark:shadow-slate-900/50':
            selectedType,
          'bg-gray-200 dark:bg-slate-700 text-gray-400 cursor-not-allowed': !selectedType,
        }"
        [disabled]="!selectedType"
        (click)="continue()"
        >
        Continuer →
      </button>
    </div>
  </div>
</div>
